/**
 * Generate period label options based on period type and year
 */
export function getPeriodOptions(periodType: "month" | "quarter" | "year", year: number): string[] {
  switch (periodType) {
    case "month":
      return [
        `January ${year}`,
        `February ${year}`,
        `March ${year}`,
        `April ${year}`,
        `May ${year}`,
        `June ${year}`,
        `July ${year}`,
        `August ${year}`,
        `September ${year}`,
        `October ${year}`,
        `November ${year}`,
        `December ${year}`,
      ];
    case "quarter":
      return [
        `Q1 ${year}`,
        `Q2 ${year}`,
        `Q3 ${year}`,
        `Q4 ${year}`,
      ];
    case "year":
      return [`FY ${year}`];
    default:
      return [];
  }
}

